import Store from 'store/store';
import { track, updateDataLayer } from 'utils/tracking';

const getActiveMovieSlug = () => {
	return Store.get()?.activePageProps?.slug || 'movie';
};

Store.on('TICKET_CONVERSION', ({ date, time, format, provider, theater, source, conversion, day, url, movieTitle, movieSlug, ticketType = 'tickets' }) => {
	const theaterName = theater?.name;
	const chainName = theater?.chain?.name;
	const activeFilmPageSlug = getActiveMovieSlug();

	updateDataLayer({ event: 'select_date', showtime_date: date, showtime_time: time, theater_chain: chainName, theater_name: theaterName });
	track(ticketType, `${ticketType}-conversion`, `${theaterName}_${chainName}_${date}_${time}_${format}_${provider}`, { movie: activeFilmPageSlug });
	track(ticketType, `${ticketType}-select-theatre-chain`, `${movieTitle}_${theaterName}_${chainName}`, { movie: activeFilmPageSlug });
	track(ticketType, `${ticketType}-select-time`, `${theaterName}_${chainName}_${date}_${time}_${format}`, { movie: activeFilmPageSlug });
	track(ticketType, `${ticketType}-select-calendar_date`, date, { movie: activeFilmPageSlug });
	updateDataLayer({ showtime_date: null, showtime_time: null, theater_chain: null, theater_name: null }); // reset values
});

Store.on('OPEN_PROVIDER_INTERSTITIAL', ({ screening, theater, ticketType = 'tickets', isMultiMovie }) => {
	const { date, time, format } = screening;
	const { name, chain } = theater;
	const chainName = chain?.name;
	track(ticketType, `${ticketType}-interstitial`, `${name}_${chainName}_${date}_${time}_${format}`, { movie: getActiveMovieSlug() });
});

Store.on('WRONG_REGION', (region, ticketType) => track(ticketType, `${ticketType}-redirect_origin`, region, { movie: getActiveMovieSlug() }));
Store.on('SHOWTIMES_ERROR', (ticketType) => track(ticketType, `${ticketType}-error`, '-', { movie: getActiveMovieSlug() }));
Store.on('SHOWTIMES_EMPTY', (region, ticketType) => {
	const { countryCode = '', city = '' } = region;
	track(ticketType, `${ticketType}-no_showtimes`, `${city}-${countryCode}`, { movie: getActiveMovieSlug() });
});

Store.on('FILTER_SELECTED_TIME', (time, ticketType = 'tickets') => {
	track(ticketType, `${ticketType}-filter_time`, time || 'Any time', { movie: getActiveMovieSlug() });
});
Store.on('FILTER_SELECTED_DAY', (date, ticketType = 'tickets') => {
	track(ticketType, `${ticketType}-filter_date`, date, { movie: getActiveMovieSlug() });
});
Store.on('FILTER_SELECTED_FORMAT', (format, ticketType = 'tickets') => {
	track(ticketType, `${ticketType}-filter_format`, format || 'Any format', { movie: getActiveMovieSlug() });
});

Store.on('GEO_FROM_IP', (geo, ticketType) => {
	const { countryCode = '', city = '' } = geo;
	track(ticketType, `${ticketType}-location-origin`, `${city}_${countryCode}`, { movie: getActiveMovieSlug() });
});
Store.on('LOCATION_SELECTED', (location, ticketType = 'tickets') => {
	const { city = '', countryCode = '' } = location || {};
	track(ticketType, `${ticketType}-search`, '', { movie: getActiveMovieSlug() });
	track(ticketType, `${ticketType}-location-update`, `${city}_${countryCode}`, { movie: getActiveMovieSlug() });
});

Store.on('HOME_ENT_CONVERSION', ({ merchant, selectedFormat }) => {
	updateDataLayer({ event: 'retailer_click', retailer: merchant });
	track('homeent', 'homeent-merchant_select', `${selectedFormat}_${merchant}`, { movie: getActiveMovieSlug() });
	updateDataLayer({ retailer: null }); // reset value
});

Store.on('NOTIFICATION_BANNER_CLICK', (type, link, ticketType) => {
	track(ticketType || type, 'notification-banner-click', link, { movie: getActiveMovieSlug() });
});
